import {
  SHOW_NOTIFICATION_DIALOG,
  HIDE_NOTIFICATION_DIALOG,
} from "../actions/action-type";

const initialState = {
  isShowing: false,
  title: "",
  content: "",
  button:''
};

const notificationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_NOTIFICATION_DIALOG:
      return {
        ...state,
        isShowing: true,
        title: payload.title,
        content: payload.content,
        button:payload.button
      };
    case HIDE_NOTIFICATION_DIALOG:
      return initialState;

    default:
      return state;
  }
};

export default notificationReducer;
